import { StateFormView } from "./RevenuePriceStateForm";

/**Wraps query string update operations for the application */
export class QueryStringController
{
	current: PriceDefinitionQueryValues;
	isQueryEmpty: boolean;

	/**Constructor for query string controller */
	constructor()
	{
		let queryValues = window.NauUtility.queryOps.getQueryParameters();

		this.isQueryEmpty = jQuery.isEmptyObject(queryValues);

		this.current = {
			State: queryValues.State,
			ReinsuranceYear: queryValues.ReinsuranceYear,
			Filter: queryValues.Filter,
			Embedded: queryValues.Embedded ? true : false,
			Modal: queryValues.Modal
		};
	}

	SetYear(year)
	{
		this.current.ReinsuranceYear = year;

		window.NauUtility.queryOps.setQueryParameters({
			'ReinsuranceYear': year
		});
	}

	Update(modalId, stateSelections: StateFormView | undefined)
	{
		this.current.State = stateSelections?.State ? stateSelections?.State : "";
		this.current.ReinsuranceYear = stateSelections?.Year ? stateSelections?.Year : "";
		this.current.Filter = stateSelections?.Filter ? stateSelections?.Filter : "All";

		window.NauUtility.queryOps.setQueryParameters({
			'State': this.current.State,
			'ReinsuranceYear': this.current.ReinsuranceYear,
			"Filter": this.current.Filter,
			"Modal": modalId
		});
	}
}

export interface PriceDefinitionQueryValues
{
	State : string,
	ReinsuranceYear: string,
	Filter: string,
	Embedded: boolean,
	Modal: string
}